import type { Sales as ApiSales } from 'apiConnector/secondary-market/shared/clients';
import type { QuantityInfo } from 'apiConnector/secondary-market/shared/referential';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { SecondaryPriceType, SecondaryQuotationType } from 'state/secondaryMarket/productSearch';
import type { TradeAuthorization } from 'state/secondaryMarket/secondaryMarket.model';
import { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';
import type { Collection } from 'state/utils/types';
import type { LoadingStatus } from 'utils/status';

export type Sales = Omit<ApiSales, 'isDefault'>;
export type OtcClient = ISalesCounterpart &
  Readonly<{
    way?: 'SG_SELL' | 'SG_BUY';
    remaining: number;
  }>;

type OtcClientData = Readonly<{
  isOtc: true;
  otcClients?: ReadonlyArray<OtcClient>;
}>;

type ListedClientData = Readonly<{
  isOtc: false;
  clients?: ReadonlyArray<ISalesCounterpart>;
}>;

type ReferentialClientData = ListedClientData | OtcClientData;

export type ReferentialExtraData = Readonly<{
  isin?: string;
  fileCode?: string;
  ric?: string;
  maturityDate?: string;
  quotationType?: SecondaryQuotationType;
  currency?: string;
  denomination?: number;
  traderGroup?: string;
  priceType?: SecondaryPriceType;
  traderLabel?: string;
  productName?: string;
  portfolio?: string;
  clientLabel?: string;
  traderMessage?: string;
  salesMessage?: string;
  bid?: number;
  ask?: number;
  extraBid?: number;
  extraAsk?: number;
  settlementHolidays?: ReadonlyArray<string>;
  firstSettlementDate?: string;
  settlements: ReadonlyArray<Settlement>;
  sales: ReadonlyArray<Sales> | undefined;
  tradeAuthorization?: TradeAuthorization;
  eligibleTraceReporting?: boolean;
}> &
  QuantityInfo;

export type Settlement = Readonly<{
  settlementType?: string;
  marketType?: 'RM' | 'IC';
  description?: string;
  isDefaultSell?: boolean;
  isDefaultBuy?: boolean;
}>;

export type ReferentialStatus = Readonly<{
  clientLoadingStatus: LoadingStatus;
  settlementLoadingStatus: LoadingStatus;
  settlementError?: SecondaryMarketFormError;
  failedToLoadSalesFromDomino?: boolean;
  infos: string[];
  warnings: string[];
  errors: string[];
}>;

export type ReferentialData = ReferentialExtraData & ReferentialClientData & ReferentialStatus;

export type ReferentialMap = Collection<ReferentialData>;

export const initialReferentialMap = (): ReferentialMap => ({});
